// extracted by mini-css-extract-plugin
var _1 = "ra-art-option-label";
var _2 = "ra-art-option-label-uppercase";
export { _1 as "artOptionLabelCls", _2 as "artOptionLabelUpperCls" }
